module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-about",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 has-text-centered aplayer-wrapper"
  }, [(_vm.music && !_vm.disabled) ? _c('vue-aplayer', {
    ref: "aplayer",
    attrs: {
      "id": "aplayer",
      "element": _vm.music.element,
      "narrow": _vm.music.narrow,
      "autoplay": _vm.music.autoplay,
      "mode": 'single',
      "music": _vm.music
    }
  }) : _c('img', {
    staticStyle: {
      "max-width": "100%",
      "padding": "5px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "350"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7 has-text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a4c006b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutSection.vue
// module id = 914
// module chunks = 1